import Masonry from 'masonry-layout'

export const testimonialsGrid = {
  container: document.querySelector('.js-testimonials-grid'),
  grid: null,
  init: function () {
    if (this.container) {
      this.grid = new Masonry(this.container, {
        itemSelector: '.js-testimonials-box',
        gutter: '.js-testimonials-gutter',
        percentPosition: true
      })
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/Grid.js